// removed by extract-text-webpack-plugin
module.exports = {"title-modal":"app-components-SubscriptionExpiredModal-__SubscriptionExpired___1d4kI","subscription-expired":"app-components-SubscriptionExpiredModal-__SubscriptionExpired___AzYDt","dialog":"app-components-SubscriptionExpiredModal-__SubscriptionExpired___25-Su","footer":"app-components-SubscriptionExpiredModal-__SubscriptionExpired___rKz-t","header-expired":"app-components-SubscriptionExpiredModal-__SubscriptionExpired___2vmM4"};


//////////////////
// WEBPACK FOOTER
// ./app/components/SubscriptionExpiredModal/SubscriptionExpired.css
// module id = 1988
// module chunks = 0